export const arrayBufferToBase64 = async (file: File): Promise<string> => {
  const buffer = await file.arrayBuffer().then((data) => {
    let binary = '';
    const bytes = new Uint8Array(data);

    for (let i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }

    return window.btoa(binary);
  });

  return buffer;
};
